module.exports = __webpack_public_path__ + "static/media/banner2.454405a0.jpg";